import type { SelectOption } from '@swf/components/Inputs/components/DropDown/DropDown';
import { Currency } from '@swf/core/enums';

import type { OptionsFilter } from '../utils/common';
import { fallback } from '../utils/common';

export interface BuyIn {
  minBuyIn: number;
  maxBuyIn: number;
  stakesLow: number;
  stakesHigh: number;
}

const useGetBuyInOptions = ({ gameData, values }: OptionsFilter): SelectOption[] => {
  if (!gameData || !gameData.length) return fallback;

  const { handType, potStruct, tableSize, currency } = values;
  const data = gameData.filter(
    (item) =>
      item.handType === handType &&
      item.potStruct === potStruct &&
      item.tableSize === tableSize &&
      (item.currency === currency || (item.currency === '' && currency === Currency.PlayMoney))
  );

  const options = data.map(({ minBuyIn, maxBuyIn, stakesLow, stakesHigh }, index) => ({
    text: `${minBuyIn} - ${maxBuyIn} BB`,
    value: JSON.stringify({ id: index, minBuyIn, maxBuyIn, stakesLow, stakesHigh })
  }));

  if (!options || !options.length) return fallback;

  return options;
};

export default useGetBuyInOptions;
